var exports = {
  "P": "xdbfd91f1--d4d8e0--index",
};

module.exports = exports;
